import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=14c612d0&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=14c612d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c612d0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3MobileMenuDrawer: require('/app/components/Theme3/Mobile/MenuDrawer.vue').default,CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme3MobilePlayerBalance: require('/app/components/Theme3/Mobile/PlayerBalance.vue').default,Theme3MobileNotificationModal: require('/app/components/Theme3/Mobile/NotificationModal.vue').default,Theme3Announcement: require('/app/components/Theme3/Announcement.vue').default,Theme3MobileExchangeRateModal: require('/app/components/Theme3/Mobile/ExchangeRateModal.vue').default,Theme3DesktopLanguageSwitcher: require('/app/components/Theme3/Desktop/LanguageSwitcher.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default})
